// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Mobile-specific styles */

@media (max-width: 768px) {
  /* Adjust chat container padding for mobile */
  .chat-container-appear {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  
  /* Adjust message bubbles for mobile */
  .message-user-bubble {
    max-width: 85vw;
  }
  
  .message-ai-bubble {
    max-width: 85vw;
  }
  
  /* Mobile chat input styles */
  .mobile-input-container {
    width: 90% !important;
    max-width: 100vw !important;
    padding-left: 8px;
    padding-right: 8px;
  }
  
  /* Adjust suggestion buttons for mobile */
  .mobile-suggestions {
    width: 90% !important;
    padding-left: 8px;
    padding-right: 8px;
  }
  
  .suggestion-button {
    margin-bottom: 8px;
  }
  
  /* Mobile brief sidebar styles */
  .mobile-brief-sidebar {
    border-radius: 24px 24px 0 0;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
  }
  
  /* Mobile file upload styles */
  .mobile-file-upload-menu {
    max-width: 90vw;
  }
  
  /* Chat window improvements for mobile */
  .mobile-chat-window {
    padding-bottom: 140px !important;
  }
  
  /* Mobile fadeout */
  .mobile-fadeout {
    height: 100px !important;
  }
  
  /* Mobile header adjustments */
  .mobile-header {
    padding: 12px 16px !important;
  }
  
  /* Brief toggle button animation */
  .mobile-brief-toggle {
    filter: drop-shadow(0 2px 8px rgba(22, 91, 251, 0.4));
    transition: all 0.3s ease;
  }
  
  .mobile-brief-toggle:active {
    transform: scale(0.95);
  }
  
  .mobile-brief-toggle.active {
    background-color: #2044cc;
  }
  
  /* Brief drag handle */
  .brief-drag-handle {
    width: 36px;
    height: 4px;
    background-color: #e1e5eb;
    border-radius: 2px;
    margin: 8px auto;
  }
}

/* Animation for brief toggle button when sidebar is open */
@keyframes pulse-brief-toggle {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

.brief-toggle-pulse {
  animation: pulse-brief-toggle 2s infinite;
}

/* Help make suggestion buttons wrap better on mobile */
@media (max-width: 380px) {
  .suggestion-button {
    font-size: 12px;
    padding: 8px 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/mobile.css"],"names":[],"mappings":";AACA,2BAA2B;;AAE3B;EACE,6CAA6C;EAC7C;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA,sCAAsC;EACtC;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,6BAA6B;EAC7B;IACE,qBAAqB;IACrB,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,yCAAyC;EACzC;IACE,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,gCAAgC;EAChC;IACE,4BAA4B;IAC5B,0CAA0C;EAC5C;;EAEA,8BAA8B;EAC9B;IACE,eAAe;EACjB;;EAEA,wCAAwC;EACxC;IACE,gCAAgC;EAClC;;EAEA,mBAAmB;EACnB;IACE,wBAAwB;EAC1B;;EAEA,8BAA8B;EAC9B;IACE,6BAA6B;EAC/B;;EAEA,kCAAkC;EAClC;IACE,qDAAqD;IACrD,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,sBAAsB;EACtB;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,2DAA2D;AAC3D;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,uDAAuD;AACvD;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["\n/* Mobile-specific styles */\n\n@media (max-width: 768px) {\n  /* Adjust chat container padding for mobile */\n  .chat-container-appear {\n    padding-left: 16px !important;\n    padding-right: 16px !important;\n  }\n  \n  /* Adjust message bubbles for mobile */\n  .message-user-bubble {\n    max-width: 85vw;\n  }\n  \n  .message-ai-bubble {\n    max-width: 85vw;\n  }\n  \n  /* Mobile chat input styles */\n  .mobile-input-container {\n    width: 90% !important;\n    max-width: 100vw !important;\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n  \n  /* Adjust suggestion buttons for mobile */\n  .mobile-suggestions {\n    width: 90% !important;\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n  \n  .suggestion-button {\n    margin-bottom: 8px;\n  }\n  \n  /* Mobile brief sidebar styles */\n  .mobile-brief-sidebar {\n    border-radius: 24px 24px 0 0;\n    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);\n  }\n  \n  /* Mobile file upload styles */\n  .mobile-file-upload-menu {\n    max-width: 90vw;\n  }\n  \n  /* Chat window improvements for mobile */\n  .mobile-chat-window {\n    padding-bottom: 140px !important;\n  }\n  \n  /* Mobile fadeout */\n  .mobile-fadeout {\n    height: 100px !important;\n  }\n  \n  /* Mobile header adjustments */\n  .mobile-header {\n    padding: 12px 16px !important;\n  }\n  \n  /* Brief toggle button animation */\n  .mobile-brief-toggle {\n    filter: drop-shadow(0 2px 8px rgba(22, 91, 251, 0.4));\n    transition: all 0.3s ease;\n  }\n  \n  .mobile-brief-toggle:active {\n    transform: scale(0.95);\n  }\n  \n  .mobile-brief-toggle.active {\n    background-color: #2044cc;\n  }\n  \n  /* Brief drag handle */\n  .brief-drag-handle {\n    width: 36px;\n    height: 4px;\n    background-color: #e1e5eb;\n    border-radius: 2px;\n    margin: 8px auto;\n  }\n}\n\n/* Animation for brief toggle button when sidebar is open */\n@keyframes pulse-brief-toggle {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.1);\n    opacity: 0.8;\n  }\n}\n\n.brief-toggle-pulse {\n  animation: pulse-brief-toggle 2s infinite;\n}\n\n/* Help make suggestion buttons wrap better on mobile */\n@media (max-width: 380px) {\n  .suggestion-button {\n    font-size: 12px;\n    padding: 8px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
